import { FC, useState } from 'react'
import { ContentItem, IImageContentItem } from '@obeta/data/lib/hooks/useArticleGalleryContent'
import { Image } from '../../../image/Image'
import { getItemUrl, renderLabel } from '../../../inline-media-box/helpers'
import { Swiper, SwiperSlide } from 'swiper/react'
import { TabFilters } from '../../../tab-filters/TabFilters'
import { MediaContentTypes } from '../../types'
import {
  PRODUCT_BUILDER_CATEGORY,
  getBuilderFilterOptions,
  getOxomiImagesByGroup,
} from '../../helpers'
import styles from './MediaItemsSection.module.scss'
import clsx from 'clsx'

type MediaItemsPanelMobileViewProps = {
  activeGroupItems: ContentItem[]
  onSetPreview: (itemIdx: number) => void
  activeContentTypeFilter: MediaContentTypes
  activeItemIndex: number
}

export const MediaItemsPanelMobileView: FC<MediaItemsPanelMobileViewProps> = ({
  activeItemIndex,
  activeGroupItems,
  onSetPreview,
  activeContentTypeFilter,
}) => {
  const [activeBuilderType, updateActiveBuilderType] = useState('')

  const getPreparedActiveItems = () => {
    if (activeContentTypeFilter === MediaContentTypes.Builder) {
      const builderItemsByGroup = getOxomiImagesByGroup(activeGroupItems as IImageContentItem[])

      // We don't know the filter names in advance, so they can be anything
      const firstKey = Object.keys(builderItemsByGroup)[0]

      return builderItemsByGroup[activeBuilderType] || builderItemsByGroup[firstKey]
    }

    return activeGroupItems
  }

  const activePreparedGroupItems = getPreparedActiveItems()

  return (
    <div className={styles.MediaItemsPanelMobileView}>
      {activeContentTypeFilter === MediaContentTypes.Builder && (
        <div className={styles.builderMediaFilters}>
          <TabFilters
            classes={{
              textClassName: styles.builderMediaFiltersText,
            }}
            spaceBetween={24}
            options={getBuilderFilterOptions(activeGroupItems as IImageContentItem[])}
            onChangeTab={(value) => updateActiveBuilderType(value)}
            activeTab={
              activeBuilderType || activePreparedGroupItems[0]?.typeName || PRODUCT_BUILDER_CATEGORY
            }
          />
        </div>
      )}

      {activePreparedGroupItems.length > 1 && (
        <Swiper
          direction="horizontal"
          loop={false}
          freeMode={true}
          slidesPerView="auto"
          pagination={false}
          spaceBetween={8}
          className={styles.mobileStripePriview}
        >
          {activePreparedGroupItems &&
            Object.entries(activePreparedGroupItems).map(([_itemKey, itemValue], index) => {
              const contentTypeLabel = renderLabel(itemValue)

              const isActive = activeItemIndex === itemValue.itemIndex

              return (
                <SwiperSlide key={index} className={styles.swiperSlide}>
                  <div
                    key={`MediaItemsPanelMobileView-${index}`}
                    className={clsx(styles.mainImageWrapper, { [styles.isActive]: isActive })}
                    role="button"
                    tabIndex={0}
                    onClick={() => onSetPreview(itemValue.itemIndex)}
                  >
                    <Image
                      variant="product"
                      src={getItemUrl(itemValue)}
                      alt={itemValue.description}
                      className={clsx(contentTypeLabel && styles.semiTransparent)}
                    />
                    {contentTypeLabel}
                  </div>
                </SwiperSlide>
              )
            })}
        </Swiper>
      )}
    </div>
  )
}
